import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject
} from '@angular/core';

export interface TosItem {
  uuid?: string;
  title: string;
  excerpt: string;
  content: string;
  required: boolean;
  toggleText: string;
  buttonLabel?: string;
  type?: string;
  videoType?: string;
  url?: string;
}

@Component({
  selector: 'bepatient-tos-summary',
  templateUrl: './tos-summary.component.html',
  styleUrls: ['./tos-summary.component.scss'],
  standalone: false
})
export class TosSummaryComponent implements AfterViewInit {
  private element = inject(ElementRef);

  @Input() tosItems: Array<TosItem>;
  @Input() color: string;
  @Output() selectItemIndex = new EventEmitter<number>();

  ngAfterViewInit(): void {
    this.element.nativeElement.style.setProperty('--data-color', this.color);
  }
}
